import { A as J, u as P } from "./use-app-2875a38b.js";
import { L as T, u as $ } from "./use-layout-167c9584.js";
import { u as L } from "./use-mobile-b816b6c7.js";
import { jsx as d } from "react/jsx-runtime";
import { useState as g, createContext as h, useMemo as S, useContext as f } from "react";
import "react-router-dom";
const w = (e, s) => {
  const [r, a] = g(() => {
    try {
      const t = window.sessionStorage.getItem(e);
      return t ? JSON.parse(t) : (window.sessionStorage.setItem(e, JSON.stringify(s)), s);
    } catch {
      return s;
    }
  });
  return [r, (t) => {
    try {
      window.sessionStorage.setItem(e, JSON.stringify(t));
    } catch (c) {
      console.error(`Error setting sessionStorage key "${e}":`, c);
    }
    a(t);
  }];
}, p = h(void 0), N = ({ children: e }) => {
  const [s, r] = w("user", null), a = async (o, n) => {
    try {
      const u = await fetch(`${n}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          email: o.userName,
          password: o.password,
          lgkey: o.lgkey
        })
      }), i = await u.json();
      return await u.status === 200 ? (console.log("認証成功"), r(i), { status: !0, user: i }) : (console.log("認証失敗"), { status: !1, user: null });
    } catch {
      return console.log("認証失敗"), { status: !1, user: null };
    }
  }, l = async (o) => {
    try {
      return await (await fetch(`${o}/logout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      })).status === 200 ? (console.log("ログアウト成功"), r(null), { status: !0, user: null }) : (console.log("ログアウト失敗"), { status: !1, user: null });
    } catch {
      return console.log("ログアウト失敗"), { status: !1, user: null };
    }
  }, t = async (o) => {
    try {
      const n = await fetch(`${o}/checkauthstatus`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      }), u = await n.json();
      return await n.status === 200 ? (console.log("ログイン中"), r(u), { status: !0, user: u }) : (console.log("ログアウト中"), { status: !1, user: null });
    } catch {
      return console.log("認証状態の確認失敗"), { status: !1, user: null };
    }
  }, c = S(
    () => ({
      user: s,
      login: a,
      logout: l,
      checkAuthStatus: t
    }),
    [s]
  );
  return /* @__PURE__ */ d(p.Provider, { value: c, children: e });
}, v = () => {
  const e = f(p);
  if (e === void 0)
    throw new Error("useAuth must be used within an AuthProvider");
  return e;
}, x = (e, s) => {
  const [r, a] = g(() => {
    try {
      const t = window.localStorage.getItem(e);
      return t ? JSON.parse(t) : (window.localStorage.setItem(e, JSON.stringify(s)), s);
    } catch {
      return s;
    }
  });
  return [r, (t) => {
    try {
      window.localStorage.setItem(e, JSON.stringify(t));
    } catch (c) {
      console.error(`Error setting localStorage key "${e}":`, c);
    }
    a(t);
  }];
};
export {
  J as AppProvider,
  N as AuthProvider,
  T as LayoutProvider,
  P as useApp,
  v as useAuth,
  L as useIsMobile,
  $ as useLayout,
  x as useLocalStorage,
  w as useSessionStorage
};
